import PropTypes from 'prop-types'
import { Routes, Route } from 'react-router-dom'

import Calificar from './calificar/Calificar'
import { Carrito } from './carrito/Carrito'
import Categorias from './categorias/Categorias'
import ContenedorCategorias from './categorias/ContenedorCategorias'
import Subcategorias from './categorias/Subcategorias'
import { CompraDirecta } from './compraDirecta/CompraDirecta'
import Compras from './compras/Compras'
import Comprobante from './compras/Comprobante'
import PasarelaPago from './compras/PasarelaPago'
import Contacto from './contacto/Contacto'
import Favoritos from './favoritos/Favoritos'
import { Lista } from './lista/Lista'
import Login from './login/Login'
import DetallePreguntas from './pages/preguntas/DetallePreguntas'
import PreguntasPublicaciones from './pages/preguntas/PreguntasPublicaciones'
import { PublicacionDetalle } from './pages/PublicacionDetalle'
import Pedidos from './pedidos/Pedidos'
import AdministrarDomicilios from './perfil/AdministrarDomicilios'
import Password from './perfil/Password'
import Perfil from './perfil/Perfil'
import DetallePresupuesto from './presupuestos/DetallePresupuesto'
import PresupuestosVendedor from './presupuestos/Presupuestos'
import PresupuestosComprador from './presupuestosComprador/Presupuestos'
import PublicacionDetalleAdmin from './publicaciones/administrar/Detalle'
import PublicacionesAdmin from './publicaciones/administrar/Publicaciones'
import Publicaciones from './publicaciones/Publicaciones'
import PublicacionGrabada from './publicar/PublicacionGrabada'
import Publicar from './publicar/Publicar'
import Registro from './registro/Registro'
import Verificar from './registro/Verificar'
import { PedidoDetalle } from './reutilizables/pedidos/PedidoDetalle'
import Scraps from './scraps/Scraps'
import ConvertirTiendaOficial from './tiendasoficiales/convertirTiendaOficial/ConvertirTiendaOficial'
import TiendasOficiales from './tiendasoficiales/TiendasOficiales'

const ContenedorPrincipal = (props) => {
  return (
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route path="/Pedidos" element={<Pedidos esVentas={false} />} />
      <Route path="/Pedidos/:idPedidoItem" element={<PedidoDetalle />} />
      <Route
        path="/PreguntasComprador"
        element={
          <PreguntasPublicaciones
            onToggleClick={props.onToggleClick}
            tipo={'comprador'}
          />
        }
      />
      <Route
        path="/PreguntasComprador/:idPublicacion/:idVendedor"
        element={<DetallePreguntas {...props} tipo={'comprador'} />}
      />
      <Route
        path="/PreguntasVendedor"
        element={
          <PreguntasPublicaciones onToggleClick={props.onToggleClick} tipo={'vendedor'} />
        }
      />
      <Route
        path="/PreguntasVendedor/:idPublicacion/:idVendedor"
        element={<DetallePreguntas {...props} tipo={'vendedor'} />}
      />
      <Route
        path="/Registro"
        element={<Registro onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Verificar/:idUsuario/:codigoVerif"
        element={<Verificar onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Favoritos"
        element={<Favoritos onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Publicaciones/Administrar"
        element={
          <PublicacionesAdmin
            onToggleClick={props.onToggleClick}
            onActualizarPantallaDetalle={props.onActualizarPantallaDetalle}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      {/* administración de Publicaciones */}
      <Route
        path="/Publicaciones/Administrar/:idPublicacion"
        element={<PublicacionDetalleAdmin />}
      />
      <Route
        path="/Publicaciones/TiendasOficiales/:idVendedor/:buscar"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route
        path="/Publicaciones/TiendasOficiales/:idVendedor"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route
        path="/Publicaciones/Subcategorias/:idSubCategoria/:buscar"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route
        path="/Publicaciones/Subcategorias/:idSubCategoria"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route
        path="/Publicaciones/Detalle/:idPublicacion"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route
        path="/Publicaciones"
        element={
          <Publicaciones
            onToggleClick={props.onToggleClick}
            onToggle={props.onToggle}
            buscar={props.buscar}
            onActualizarPantalla={props.onActualizarPantalla}
            actualizarPantalla={props.actualizarPantalla}
          />
        }
      />
      <Route path="/Publicacion/:id" element={<PublicacionDetalle />} />
      <Route path="/Publicar" element={<Publicar />} />
      <Route
        path="/TiendasOficiales"
        element={<TiendasOficiales onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/ConvertirTiendaOficial"
        element={<ConvertirTiendaOficial onToggleClick={props.onToggleClick} />}
      />
      <Route path="/Presupuestos" element={<PresupuestosVendedor />} />
      <Route path="/Presupuesto/:idPresupuesto" element={<DetallePresupuesto />} />
      <Route
        path="/PresupuestosComprador"
        element={<PresupuestosComprador onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Perfil"
        element={
          <Perfil
            onToggleClick={props.onToggleClick}
            cambiarImagenPerfil={props.cambiarImagenPerfil}
          />
        }
      />
      <Route
        path="/AdministrarDomicilios"
        element={<AdministrarDomicilios onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Password"
        element={<Password onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Contacto"
        element={<Contacto onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/CalificarVendedor/:idPublicacion/:idVendedor/:idPedidoItem"
        element={<Calificar onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/CalificarProducto/:idPublicacion/:idVendedor/:idPedidoItem"
        element={<Calificar onToggleClick={props.onToggleClick} />}
      />
      <Route path="/Carrito" element={<Carrito />} />
      <Route path="/compras" element={<Compras onToggleClick={props.onToggleClick} />} />
      <Route
        path="/compras/:idPublicacion"
        element={<Compras onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/PasarelaPago"
        element={<PasarelaPago onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Comprobante/:idPedido"
        element={<Comprobante onToggleClick={props.onToggleClick} />}
      />
      <Route path="/Ventas" element={<Pedidos esVentas={true} />} />
      <Route
        path="/Categorias"
        element={<ContenedorCategorias onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Categorias/:categoria"
        element={<Categorias onToggleClick={props.onToggleClick} />}
      />
      <Route
        path="/Subcategorias/:idCategoria/:descripcion"
        element={<Subcategorias onToggleClick={props.onToggleClick} />}
      />
      <Route path="/Scraps" element={<Scraps />} />
      <Route path="/PublicacionGrabada" element={<PublicacionGrabada />} />
      <Route
        path="/PublicacionesOfertas"
        element={<Publicaciones onToggleClick={props.onToggleClick} ofertas="S" />}
      />
      <Route
        path="/compraDirecta"
        element={<CompraDirecta onToggleClick={props.onToggleClick} />}
      />
      <Route path="/Listas" element={<Lista onToggleClick={props.onToggleClick} />} />
    </Routes>
  )
}

ContenedorPrincipal.propTypes = {
  onToggleClick: PropTypes.func.isRequired,
  onActualizarPantallaDetalle: PropTypes.func.isRequired,
  actualizarPantalla: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  buscar: PropTypes.func.isRequired,
  onActualizarPantalla: PropTypes.func.isRequired,
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default ContenedorPrincipal
